import React from 'react';
import { Link } from 'react-router-dom';

/**
 * Contact page — points visitors to the club for ordering, and to email for
 * partnerships, press, retail, or joining the team.
 */
export function ContactPage() {
  return (
    <>
      <section className="section fade-in">
        <div className="section-label">Contact</div>
        <h2>Get in touch.</h2>
        <p>
          We’re making TrueNooch in small batches in Colorado and selling direct.
          Want it? <Link to="/club" style={{ color: 'var(--gold)' }}>Join the club</Link> —
          you’ll get first dibs on every batch.
        </p>
        <p>
          For partnerships, press, retail conversations, or{' '}
          <Link to="/team" style={{ color: 'var(--gold)' }}>joining the team</Link> — email{' '}
          <a href="mailto:jarvis@truenooch.com" style={{ color: 'var(--gold)' }}>jarvis@truenooch.com</a> directly.
        </p>
      </section>
    </>
  );
}
